module.exports = __webpack_public_path__ + "img/Kevin.2c44858c.png";